import { viewSelector } from "@verified/c11-engine.patterns";
import { Error, Summary, Loading, Login} from "./states";
import * as producers from "./producers"

enum States {
    LOGIN = "login",
    LOADING = "loading",
    SUMMARY = "summary",
    ERROR = "error",
}

type StateData = {
    error: string;
    areEnvelopesLoaded: boolean;
    isAuthenticated: boolean;
    isLoading: boolean;
};

const selector = ({
    isAuthenticated,
    areEnvelopesLoaded,
    error,
    isLoading
}: StateData) => {
    const hasAccessToken = window.sessionStorage.getItem('accessToken') !== null;

    if (error) {
        return States.ERROR;
    } else if (hasAccessToken || isAuthenticated) {
        return areEnvelopesLoaded ? States.SUMMARY : States.LOADING;
    } else {
        return States.LOGIN;
    }
};

const stateMap = {
    [States.LOGIN]: Login,
    [States.LOADING]: Loading,
    [States.ERROR]: Error,
    [States.SUMMARY]: Summary,
};

export const EnvelopesDashboard = viewSelector(
    stateMap,
    selector,
    producers
);
